<template>
  <div>
    <v-layout>
      <v-flex sm4 offset-sm8>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <br />
    <v-data-table
      :headers="headers"
      :items="agentMembers"
      class="elevation-1"
      :search="search"
      :loading="loading"
    >
      <template v-slot:items="props">
        <td class="text-xs-right">{{ ++props.index }}</td>
        <td class="text-xs-right">{{ props.item.dasher_id }}</td>
        <td class="text-xs-center">{{ props.item.first_name }}</td>
        <td class="text-xs-center" style="min-width: 260px" v-if="status">
          <div class="actions" v-if="status == 'active'">
            <v-btn small color="error" @click="deactivate(props.item.id)">
              Deactivate
            </v-btn>
          </div>
          <div class="actions" v-else-if="status == 'inactive'">
            <v-btn small color="success" @click="activate(props.item.id)">
              Activate
            </v-btn>
          </div>
          <div class="actions" v-else-if="status == 'pending'">
            <v-btn small color="success" @click="accept(props.item.id)">
              Accept
            </v-btn>
            <v-btn small color="error" @click="reject(props.item.id)">
              Reject
            </v-btn>
          </div>
        </td>
      </template>
    </v-data-table>
    <v-snackbar v-model="snackbar" :color="color" bottom right>
      {{ msg }}
    </v-snackbar>
  </div>
</template>
<script>
  import api from "../../api/datadash";
  import { mapState } from "vuex";
  export default {
    props: ["agentMembers", "loading", "status"],
    data() {
      return {
        search: "",
        headers: [
          {
            text: "#",
            align: "right",
            value: "",
          },
          { text: "Dasher ID", align: "right", value: "dasher_id" },
          { text: "Name", align: "center", value: "first_name" },
        ],
        snackbar: false,
        color: "success",
        msg: "Updated successfully",
      };
    },
    computed: {
      ...mapState(["auth"]),
    },
    created() {
      this.status &&
        this.headers.push({ text: "Action", align: "center", value: "" });
    },
    methods: {
      async activate(id) {
        var popUpMsg = confirm("Are you sure you want to activate this?");
        if (popUpMsg) {
          const { data } = await api.storeData(
            this.auth.token,
            "agent.group.member-activation",
            { id }
          );
          if (!data.error) {
            this.$emit("refetch");
            this.color = "success";
            this.msg = "Activated Successfully";
            this.snackbar = true;
          }
        }
      },
      async deactivate(id) {
        var popUpMsg = confirm("Are you sure you want to Deactivate this?");
        if (popUpMsg) {
          const { data } = await api.storeData(
            this.auth.token,
            "agent.group.member-activation",
            { id }
          );
          if (!data.error) {
            this.$emit("refetch");
            this.color = "success";
            this.msg = "Deactivated Successfully";
            this.snackbar = true;
          }
        }
      },
      async accept(id) {
        var popUpMsg = confirm("Are you sure you want to Accept this?");
        if (popUpMsg) {
          const { data } = await api.storeData(
            this.auth.token,
            "agent.group.member-verify",
            { id, verification_status: 1 }
          );
          if (!data.error) {
            this.$emit("refetch");
            this.color = "success";
            this.msg = "Accepted Successfully";
            this.snackbar = true;
          }
        }
      },
      async reject(id) {
        var popUpMsg = confirm("Are you sure you want to Reject this?");
        if (popUpMsg) {
          const { data } = await api.storeData(
            this.auth.token,
            "agent.group.member-verify",
            { id, verification_status: 0 }
          );
          if (!data.error) {
            this.$emit("refetch");
            this.color = "success";
            this.msg = "Rejected Successfully";
            this.snackbar = true;
          }
        }
      },
    },
  };
</script>
<style scoped>
  .actions {
    display: none;
  }
  tr:hover td > .actions {
    display: block;
  }
</style>
